const getComparisonOptions = (toolConfig) => {
  return [
    {
      value: "on",
      disabled: false,
    },
    {
      value: "off",
      disabled: toolConfig.dataset.multipleSeries ? false : true,
    },
  ];
};

const getChartTypeOptions = (toolConfig) => {
  return [
    {
      value: "area",
      disabled: toolConfig.comparison === "on" ? true : false,
    },
    { value: "line", disabled: false },
    {
      value: "map",
      disabled: true,
    },
  ];
};

const getDataTreatmentOptions = (toolConfig) => {
  return [
    {
      value: "absolute",
      disabled: false,
    },
    { value: "% share", disabled: !toolConfig.dataset.relativeValue },
  ];
};

const isFocusAvailable = (toolConfig) => {
  return toolConfig.dataset.multipleSeries ? true : false;
};

export {
  getComparisonOptions,
  getChartTypeOptions,
  getDataTreatmentOptions,
  isFocusAvailable,
};
